define('controllers/incentive/myIncentive.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('myIncentiveCtrl', ['$q', '$stateParams', '$location', 'OpenApp', '$state', 'auiDialog', '$scope', 'UserInfo', '$rootScope', 'auiMyIncentiveService', 'OpenOther', 'OpenApp', 'tenantsService', 'OpenTrade', 'auiSettlementService', 'ngDialog', '$filter', 'auiAgreementHelper', 'payService', 'modBussService', 'myIncentiveService', 'OpenOther',
        function ($q, $stateParams, $location, OpenApp, $state, auiDialog, $scope, UserInfo, $rootScope, auiMyIncentiveService, OpenOther, OpenApp2, tenantsService, OpenTrade, auiSettlementService, ngDialog, $filter, auiAgreementHelper, payService, modBussService, myIncentiveService, openOther) {
            var lang = 'zh_CN';
            if (sysParamCfg.switchConf.angularHandover4Incentive) {
                $state.go('incentive');
                return;
            }
            var helpCenterUrl = sysParamCfg.helpCenterUrl;
            var Model = $scope.Model = {
                acceptanceList: [],
                acceptanceOrderList: [],
                signedAgreeList: [],
                showAcceptanceList: true,
                showOfferBtn: false
            };
            Model.constant = {
                promoteItem: mainCons.incentiveConstant.promoteItem,
                applyType: mainCons.incentiveConstant.applyType,
                state: mainCons.incentiveConstant.state,
                billStatus: mainCons.incentiveConstant.billStatus,
                promotePayMode: mainCons.incentiveConstant.promotePayMode,
                lmArgType: sysParamCfg.incentiveFrameAgreement.lm,
                hmsArgType: sysParamCfg.incentiveFrameAgreement.hms
            };
            Model.viewDetail = viewDetail;
            Model.gotoApply = gotoApply;
            Model.getOfferList = auiMyIncentiveService.showOffer;
            Model.acceptance = {
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 5,// 默认每页个数
                        itemsPerPageBackUp: 5,
                        totalCount: 0,
                        noItems: "No Data",
                        pagesLength: 5,// 显示的页码数量,
                        onChange: queryAcceptanceList
                    }
                }
            };
            Model.acceptanceOrder = {
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 5,// 默认每页个数
                        itemsPerPageBackUp: 5,
                        totalCount: 0,
                        noItems: "No Data",
                        pagesLength: 5,// 显示的页码数量,
                        onChange: queryAcceptanceOrderList
                    }
                }
            };

            // 下载结算单、明细
            $scope.downloadBill = myIncentiveService.downloadBill;
            // 查看发票
            $scope.displaySelfBilling = myIncentiveService.displaySelfBilling;
            $scope.showAgreement = showAgreements;
            $scope.confirmSettlement = confirmSettlement;
            var merUrl = sysUrlCfg.user.memberCenterUrl + '#/mysetting/modBussnessInfo';
            var payUrl = sysUrlCfg.user.memberCenterUrl + '#/mysetting/modPayService/modInvoice';

            //页面初始化
            initPage();

            function initPage() {
                if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                    auiDialog.warn("提醒", "激励金当前不支持团队帐号，请到右上角切换至您自己的帐号下使用。", function () {
                        $state.go('mysetting', {reload: true});
                    });
                } else {
                    UserInfo.promise().then(function (userInfo) {
                        if (userInfo.verifyRealState != 2) {
                            auiDialog.warn("提醒", "您的实名认证信息还在审核中，如果有疑问请联系客服。", function () {
                                $state.go('mysetting', {reload: true});
                            });
                        } else {
                            tenantsService.isBankVoid().then(function (isMerchant) {
                                if (!isMerchant) {
                                    auiDialog.warn('提醒', '您的<a class="text-link" target="_blank" href="' + merUrl + '">商户服务</a>还未开通或者还处于审核中，如果有疑问请联系客服。', function () {
                                        init();
                                    });
                                } else {
                                    if (userInfo.userType == 2 && !payService.getPayDialogIsShow()) {
                                        payService.isPayable().then(function (isPay) {
                                            if (!isPay) {
                                                auiDialog.confirm("提示", '您的付费服务还未开通，建议您开通<a class="text-link" target="_blank" href="' + payUrl + '">付费服务</a>。', function () {
                                                    $state.go('mysetting.payService.modInvoice', {}, {reload: true});
                                                }, {
                                                    btnOK: "去开通",
                                                    btnCancel: "暂不开通"
                                                }, function () {
                                                    payService.setPayDialogIsShow();
                                                    init();
                                                });
                                            } else {
                                                init();
                                            }
                                        });
                                    } else {
                                        init();
                                    }
                                }
                            });
                        }
                    });
                }
            }

            function initList() {
                auiMyIncentiveService.offeringBlockingJudgment().then(function (data) {
                    queryAcceptanceList();
                    OpenOther.queryOfferSignList({
                        req: {
                            fromRecCount: 1,
                            maxReqCount: 20
                        }
                    }).then(function (resp) {
                        if (resp && resp.offerSignList && resp.offerSignList.length > 0) {
                            Model.showOfferBtn = true;
                        }
                    });
                    tenantsService.isBankVoid().then(function (isMerchant) {
                        if (isMerchant) {
                            queryAcceptanceOrderList();
                        }
                    });
                });
            }

            function init() {
                //先判断是否需要签署框架协议
                OpenOther.queryUserToSignPrmtAgmt().then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.checkRes = data.checkRes;
                        if (data.checkRes == 2) {
                            initList();
                        } else {
                            OpenOther.needSignAgreement({req: {}}).then(function (res) {
                                if (res && res.resultCode === 0 && res.isNeed === 1) {
                                    auiAgreementHelper.queryAgreements([Model.constant.lmArgType]).then(function (signInfo) {
                                        if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                                            var signedText = signInfo.signInfoList[0];
                                            if (signedText.signStatus == 1) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                                initList();
                                                Model.signedAgreeList.push(Model.constant.lmArgType);
                                            } else if (signedText.signStatus == 2) {
                                                signIncentive();
                                            } else {
                                                queryHmsAgreeSignStatus();
                                            }
                                        } else {
                                            auiDialog.failSystemError();
                                        }
                                    });
                                } else if (res && res.resultCode === 0 && res.isNeed === 0) {
                                    initList()
                                }
                            })
                        }
                    }
                }).catch(function (data) {
                    if (data && data.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                    }
                });
                // 查询商户状态
                modBussService.getBussinesInfo('00011111111111', function (resp) {
                    Model.userInfo = angular.copy(resp);
                    Model.developerInfo = angular.copy(resp.developerInfo);
                });

                // 获取商户信息的审核状态
                modBussService.getBussinesInfo('00010001001', function (resp) {
                    // 用户的银行信息
                    Model.bankInfoCN = angular.copy(resp.bankInfoCN);
                    Model.bankInfoEN = angular.copy(resp.bankInfoEN);
                });
            }


            function confirmSettlement(row) {
                var defer = $q.defer();
                // 单条结算
                inCurrencyList(row, {
                    cb: function () {
                        auiSettlementService.confirmSettlementToOpenTrade(row, "AP", function () {
                            defer.resolve();
                        }, false, Model.userInfo, function () {
                            auiDialog.success('已请求结算。', function () {
                                //重新查询数据，解决不刷新可以重复点击确认问题
                                initList();
                                defer.resolve();
                            });
                        }, function (resp) {
                            auiDialog.failSystemError($filter('auiErrorCode')(resp, resp.serviceName), function () {
                                //重新查询数据，解决不刷新可以重复点击确认问题
                                initList();
                                defer.reject();
                            });
                        });
                    },
                    cbForClose: function () {
                        defer.resolve();
                    }
                });

                return defer.promise;
            }


            function inCurrencyList(row, options) {
                //判断是否在cp商户服务支持的币种中，引导转至商户设置页面
                var currencyArr = '';
                if (mainCons.settlementConstant.signEntityBankMap[row.signEntityCode] === '0') {
                    if (!Model.bankInfoCN || !Model.bankInfoCN.bankName) {
                        auiDialog.confirm('您的境内收款账户信息不完善，请先维护账户信息', function () {
                            $state.go('mysetting.modBussnessInfo', {settlement: 'AccountSettlement'}, {reload: true});
                        }, function () {
                            options.cbForClose();
                        });
                    } else {
                        currencyArr = Model.bankInfoCN.currency.split(',');
                        openDlgForCurrency(row, currencyArr, options);
                    }

                } else {
                    if (!Model.bankInfoEN || !Model.bankInfoEN.bankName) {
                        auiDialog.confirm('您的跨境收款账户信息不完善，请先维护账户信息。', function () {
                            $state.go('mysetting.modBussnessInfo', {settlement: 'AccountSettlement'}, {reload: true});
                        }, function () {
                            options.cbForClose();
                        });
                    } else {
                        currencyArr = Model.bankInfoEN.currency.split(',');
                        openDlgForCurrency(row, currencyArr, options);
                    }
                }
            }


            function openDlgForCurrency(row, currencyArr, options) {
                if (!AUI.BaseJSUtil.contains(currencyArr, row.currencyType)) {
                    myIncentiveService.dlgForCurrency(Model, options);
                } else {
                    options.cb();
                }
            }


            //签署1095协议
            function signIncentive() {
                auiAgreementHelper.checkAgreements([{
                    agrType: Model.constant.lmArgType,
                    country: 'cn',
                    count: 1
                }], function () {
                    $state.go('serviceCards', {dirId: 'AppService'}, {reload: true});
                }, null, true).then(function (result) {
                    if (result.signed) {
                        initList();
                        Model.signedAgreeList.push(Model.constant.lmArgType);
                    }
                });
            }

            //判断1083协议有没有签署
            function queryHmsAgreeSignStatus() {
                auiAgreementHelper.queryAgreements([Model.constant.hmsArgType]).then(function (signInfo) {
                    if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                        var signedText = signInfo.signInfoList[0];
                        if (signedText.signStatus == 1) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                            initList();
                            Model.signedAgreeList.push(Model.constant.hmsArgType);
                        } else {
                            signIncentive();
                        }
                    } else {
                        auiDialog.failSystemError();
                    }
                });
            }

            function showAgreements() {
                var defer = $q.defer();
                auiAgreementHelper.viewAndDownloadAgreements(Model.signedAgreeList).then(function (data) {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


            function queryAcceptanceList() {
                OpenOther.getAcceptanceList({
                    req: {
                        fromRecCount: (Model.acceptance.query.pagination.currentPage - 1) * (Model.acceptance.query.pagination.itemsPerPage) + 1,
                        maxReqCount: Model.acceptance.query.pagination.itemsPerPage
                    }
                }).then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.acceptance.query.pagination.totalCount = data.totalCount;
                        Model.acceptanceList = data.acceptanceList;
                        if (!Model.acceptanceList) {
                            Model.acceptanceList = []
                        }
                        if (Model.acceptanceList && Model.acceptanceList.length > 0) {
                            var appIDs = [];
                            angular.forEach(Model.acceptanceList, function (acceptance) {
                                if (acceptance.subAppID) {
                                    appIDs.push(acceptance.subAppID);
                                } else {
                                    appIDs.push(acceptance.appID);
                                }
                            });
                            var appIdList = [];
                            angular.forEach(Model.acceptanceList, function (acceptance) {
                                if (!acceptance.appName) {
                                    if (acceptance.subAppID) {
                                        appIdList.push(acceptance.subAppID)
                                    } else {
                                        appIdList.push(acceptance.appID)
                                    }
                                }
                            });
                            OpenApp.getProductByID({
                                request: {
                                    prodID: appIdList
                                }
                            }).then(function (res) {
                                if (res && res.productList && res.productList.length > 0) {
                                    angular.forEach(res.productList, function (prod) {
                                        angular.forEach(Model.acceptanceList, function (app) {
                                            if (prod.prodID == app.appID || prod.prodID == app.subAppID) {
                                                app.appName = prod.prodName
                                            }
                                        })
                                    })
                                }
                            })
                            OpenOther.queryInsAppList({
                                req: {
                                    prodIDList: AUI.BaseJSUtil.unique(appIDs)
                                }
                            }).then(function (resp) {
                                if (resp && resp.resultCode == 0) {
                                    angular.forEach(Model.acceptanceList, function (acceptance) {
                                        angular.forEach(resp.appSrvList, function (appSrv) {
                                            var appInfo = appSrv.appInfo;
                                            if (acceptance.subAppID && acceptance.subAppID == appInfo.appID) {
                                                acceptance.appName = appInfo.appName;
                                            }
                                            if (!acceptance.subAppID && acceptance.appID == appInfo.appID) {
                                                acceptance.appName = appInfo.appName;
                                            }
                                        });
                                    })
                                }
                            });
                            // 获取激励类型信息
                            getDeliveriesIncentiveType();
                        }

                        if (data.totalCount > 0) {
                            Model.showAcceptanceList = true;
                        } else {
                            Model.showAcceptanceList = false;
                        }
                    } else {
                        auiDialog.fail("获取申请记录失败。");
                    }
                }).catch(function (data) {
                    auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                });
            }

            function queryAcceptanceOrderList() {
                Model.query = {
                    billStatus: ['developer'], //结算单状态
                    businessType: ["100", "200"].join(','),//业务类型
                    billType: "AP" //应收AR 应付AP
                };
                OpenTrade.getSettlement({req: Model.query}).then(function (resp) {
                    Model.billTotallist = resp.billInfos;
                    Model.acceptanceOrder.query.pagination.totalCount = Model.billTotallist.length;
                    if (Model.billTotallist && Model.billTotallist.length > 0) {
                        var appIDs = [];
                        angular.forEach(Model.billTotallist, function (bill) {
                            if (typeof (bill.appID) != "string") {
                                bill.appID = bill.appID.toString();
                            }
                            appIDs.push(bill.appID);
                        });

                        OpenOther.queryInsAppList({
                            req: {
                                prodIDList: AUI.BaseJSUtil.unique(appIDs)
                            }
                        }).then(function (resp) {
                            if (resp && resp.resultCode == 0) {
                                angular.forEach(Model.billTotallist, function (bill) {
                                    angular.forEach(resp.appSrvList, function (appSrv) {
                                        var appInfo = appSrv.appInfo ? appSrv.appInfo : appSrv;
                                        if (bill.appID == appInfo.appID) {
                                            bill.appName = appInfo.appName;
                                        }
                                    });
                                });
                                pageChangeDownload();
                                // 获取发放记录中的激励类型
                                getDeliveriesIncentiveType();
                            }
                        });
                    }
                }).catch(function () {

                });

            }


            // 获取激励类型枚举值映射
            function getDeliveriesIncentiveType() {
                var promoteItemListArray = [];
                Model.prmtLangObj2 = {};
                Model.acceptanceOrderList.forEach(function (row) {
                    promoteItemListArray.push(row['promoteItem']);
                    row['endTime'] = '';
                    if (row['historyNodeInfos'] && row['historyNodeInfos'].length > 0) {
                        row['historyNodeInfos'].forEach(function (hisNode) {
                            if (hisNode['invStat'] == row['billStatus'] && (row['billStatus'] == 'P050' || row['billStatus'] == 'P060')) {
                                row['endTime'] = hisNode['nodeCreateTime'];
                            }
                        });
                    }
                });
                Model.acceptanceList.forEach(function (row) {
                    promoteItemListArray.push(row['promoteItem'])
                });
                promoteItemListArray = AUI.BaseJSUtil.unique(promoteItemListArray);
                myIncentiveService.getPromotionItemList(promoteItemListArray).then(function (data) {
                    if (data && data.length > 0) {
                        data.forEach(function (item) {
                            Model.prmtLangObj2[item.prmtId] = item.prmtLang
                        })
                    }
                });
            }


            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeDownload() {
                var result = auiSettlementService.pagination(Model.billTotallist, Model.acceptanceOrder.query.pagination, true);
                Model.acceptanceOrderList = result.listForShow;

            }

            function viewDetail(row) {
                $state.go('myIncentiveDetail', {
                    serialNum: row.serialNum,
                    appName: row.appName
                });
            }


            function gotoApply() {
                tenantsService.isBankVoid().then(function (isMerchant) {
                    if (!isMerchant) {
                        auiDialog.warn('提醒', '您的<a class="text-link" target="_blank" href="' + merUrl + '">商户服务</a>还未开通或者还处于审核中，如果有疑问请联系客服。', function () {

                        });
                    } else {
                        myIncentiveService.queryInspireApp().then(function (data) {
                            if (data && data.resultCode == 0) {
                                var appList = data.inspireAppAbsList;
                                if (appList && appList.length > 0) {
                                    $state.go('myIncentiveApply');
                                } else {
                                    auiDialog.warn('提醒', '您申请激励项的应用合同或Offer尚未录入，暂时无法申请，请在该合同/Offer录入后申请。若有任何疑问，请<a class="text-link" target="_blank" href="' + helpCenterUrl + '">联系客服</a>。');
                                }
                            }
                        });
                    }
                });
            }

        }]);
});

